export const ModalMode = {
  NEW: 'new',
  EDIT: 'edit',
  CLOSED: 'closed',
};

/** Matches backend `MigrationDriver.POS_HUB` / menu API `migration_driver` string. */
export const POSHUB_MENU_DRIVER = 'PosHub';
